import { commonTranslationKeys, FieldControllerProps, FormContextValues } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

import { prefixFieldName } from './common.utils';

type HouseFieldProps = Pick<FormContextValues, 'register'> &
   Pick<FieldControllerProps<'house', string | null>, 'name' | 'required'> &
   ClassNameProp & {
      readonly prefix?: string;
   };

export const HouseField = (props: HouseFieldProps): JSX.Element => {
   const { name, prefix, required, register } = props;
   const fieldName = prefixFieldName(name, prefix);
   return (
      <TextInput
         controller={register(fieldName, {
            maxLength: 20,
            required: required,
         })}
         label={commonTranslationKeys.addressData.houseNumberAbbreviation}
         testId={fieldName}
      />
   );
};
